/**
 * "ⓘ" icon button that toggles a row's expanded detail surface.
 *
 * Used on inventory tables so the operator can drill into a single
 * ONU / VDSL port without leaving the chassis page. The row-click
 * action is intentionally absent (CopyableCell handles cells) — the
 * info icon is the only affordance that expands, avoiding accidental
 * drill-through when reaching for the clipboard.
 */
import { Info } from "lucide-react";

export function InfoExpandButton({
  expanded,
  onClick,
  label,
}: {
  expanded: boolean;
  onClick: () => void;
  /** Accessibility label, e.g. "Expand row 0/4/9". */
  label?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={expanded}
      aria-label={label ?? (expanded ? "Hide detail" : "Show detail")}
      title={expanded ? "Hide detail" : "Show detail"}
      className={[
        "inline-flex h-6 w-6 items-center justify-center rounded",
        "text-slate-500 hover:bg-slate-800 hover:text-slate-200",
        "transition-[scale,background-color,color] duration-150 ease-out",
        "active:scale-[0.96]",
        "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-emerald-500",
        expanded ? "bg-slate-800 text-emerald-300" : "",
      ].join(" ")}
    >
      <Info className="h-3.5 w-3.5" />
    </button>
  );
}
